// extracted by mini-css-extract-plugin
export default {"centered":"LoginCallbackPage_centered__JkbU-","loginForm":"LoginCallbackPage_loginForm__74nx3"};